<template>
    <div class="content md">
        <system-admin type="act"></system-admin>
    </div>
</template>

<script>
    import SystemAdmin from "../../layouts/SystemAdmin";
    export default {
        name: "ActAdmin",
        components: {
            SystemAdmin
        }
    }
</script>

<style scoped>

</style>
